module.exports = __webpack_public_path__ + "57abc32df38eb5744d8d5fa2ec4d3698.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fossil-fuel-insurance-company-table.png
// module id = 598
// module chunks = 0